/* eslint-disable no-undef, no-unused-vars, react-hooks/exhaustive-deps, @typescript-eslint/no-unused-vars */
/**
 * Top traders tab of dexx trades
 */
import { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { ITopWalletsResponseItem } from '@kattana-io/common';
import TopTradersTable from './Table';
import { IStore } from '../../../reducers';
import TopTradersTableMobile from './TableMobile';
import { KattanaAPI } from '../../../store/createStore';

export interface ITopTradersSelector {
  exchange: string;
  base: string;
  quote: string;
  base_decimals: number;
  quote_decimals: number;
  flipped: boolean;
  rates: any;
  address: string | undefined;
  chain: string;
}

const selector = (state: IStore): ITopTradersSelector => {
  const [base, quote] = state.current.name.split('/');
  return {
    exchange: state.current.exchange,
    base,
    quote,
    address: state.current.address,
    base_decimals: state.current.base_decimals,
    quote_decimals: state.current.quote_decimals,
    rates: state.rates.items,
    flipped: state.current.flipped,
    chain: state.current.chain,
  };
};

export enum EWalletsTimeframes {
  DAY = 'Day',
  WEEK = 'Week',
  MONTH = 'Month',
}

interface ITopTradersProps {
  width?: number;
  isMobile?: boolean;
}

const TopTradersDataLayer = ({ width, isMobile }: ITopTradersProps) => {
  const state = useSelector(selector);

  const { address, chain } = state;

  const [loading, setLoading] = useState(true);
  const [isError, setError] = useState(false);

  const [timeframe, setTimeframe] = useState(
    isMobile ? EWalletsTimeframes.WEEK : EWalletsTimeframes.DAY
  );
  const [filterValue, setFilterValue] = useState('');
  const [wallets, setWallets] = useState<ITopWalletsResponseItem[]>([]); // all wallets
  const [collection, setCollection] = useState<ITopWalletsResponseItem[]>([]); // filtered

  useEffect(() => {
    setCollection(
      wallets.filter((item) =>
        item.wallet
          .toLocaleLowerCase()
          .includes(filterValue.toLocaleLowerCase())
      )
    );
  }, [filterValue]);

  useEffect(() => {
    if (address) {
      setLoading(true);
      KattanaAPI
        .topTraders(address, chain, timeframe.toLocaleLowerCase())
        .then((res: ITopWalletsResponseItem[]) => {
          setWallets(res);
          setCollection(
            res.filter((item: ITopWalletsResponseItem) =>
              item.wallet.toLocaleLowerCase().includes(filterValue)
            )
          );
        })
        .catch(() => setError(true))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
      // setData([]);
    }
  }, [timeframe, address]);

  const onSetTimeframe = (time: EWalletsTimeframes) => {
    setTimeframe(time);
  };

  // const collection = wallets.filter((item) => item.wallet.includes(filterValue));

  if (isError) {
    return <div className='tableCell centrify'>Error</div>;
  }

  return isMobile ? (
    <TopTradersTableMobile
      {...state}
      loading={loading}
      wallets={collection}
    />
  ) : (
    <TopTradersTable
      {...state}
      loading={loading}
      wallets={collection}
      timeframe={timeframe}
      handleSetTimeframe={onSetTimeframe}
      width={width}
    />
  );
};

const mapStateToProps = (state: IStore) => ({
  address: state.current.address,
});

export default connect(mapStateToProps)(TopTradersDataLayer);
